module.exports = ".sitesContainer{padding-top:15px;text-align:center}.mat-list-item{float:right}"